/** 内置策略注册表（F-007）：清单 + 按 id 工厂，供 UI 下拉与策略页使用。 */
import type { DispatchStrategy } from './strategy-api';
import { createFcfsStrategy } from './builtin/fcfs';
import { createNearestCarStrategy } from './builtin/nearest-car';
import { createScanLookStrategy } from './builtin/scan-look';
import { createZoningStrategy } from './builtin/zoning';
import { createCostGroupStrategy } from './builtin/cost-group';

export interface StrategyDescriptor {
  readonly id: string;
  readonly name: string;
  readonly description: string;
  readonly make: () => DispatchStrategy;
}

export const BUILTIN_STRATEGIES: readonly StrategyDescriptor[] = [
  {
    id: 'fcfs',
    name: 'FCFS 先来先服务',
    description: '呼叫按到达顺序排队，空闲轿厢依次取队首服务，一车一呼。',
    make: createFcfsStrategy,
  },
  {
    id: 'nearest-car',
    name: '最近轿厢响应',
    description: '为每个呼叫选择预计到达时间最短的空闲轿厢。',
    make: createNearestCarStrategy,
  },
  {
    id: 'scan-look',
    name: 'SCAN/LOOK 扫描',
    description: '优先指派给方向一致且将顺路经过的轿厢，鼓励连续扫梯。',
    make: createScanLookStrategy,
  },
  {
    id: 'zoning',
    name: '分区调度',
    description: '楼层均分为若干区，每台电梯专职服务本区呼叫。',
    make: createZoningStrategy,
  },
  {
    id: 'cost-group',
    name: '代价函数群控',
    description: '按等待+绕行+满载加权代价为每个 (呼叫, 轿厢) 配对，权重可调。',
    make: createCostGroupStrategy,
  },
];

export function findStrategy(id: string): StrategyDescriptor | undefined {
  return BUILTIN_STRATEGIES.find((s) => s.id === id);
}

/** 策略 id → 中文名（展示/报告用）。 */
export function strategyLabel(id: string): string {
  if (id === 'rule-engine') return '自定义规则引擎';
  return findStrategy(id)?.name ?? id;
}

export function createStrategy(id: string): DispatchStrategy {
  const desc = findStrategy(id) ?? BUILTIN_STRATEGIES[1]!; // 兜底：最近轿厢
  return desc.make();
}
